import type { DialogueLogType } from '@shared/types/dialogue-log';

/** タイトル未入力時に本文先頭行から自動生成する際の最大文字数。 */
const MAX_DERIVED_TITLE_LENGTH = 40;

/**
 * タイムライン登録 payload の `title` を生成する。
 *
 * timeline-email-minimal-entry 仕様: 手動追加モーダルでは title を任意入力に
 * するが、 DB / backend domain の `title NOT NULL` は維持するため、 送信前に
 * 必ず非空文字列へ落とす。
 *
 * 1. ユーザー入力 (trim) が非空ならそれを使う。
 * 2. 本文の先頭の非空行があれば使う (長い場合は約 40 文字で丸める)。
 * 3. それも無ければ対話方法の既定 (`email` → 「メール」 / `other` → 「その他」 /
 *    残り → 「タイムライン」)。
 *
 * AI 解析・ 件名/差出人抽出は行わない純粋なフォールバックロジック。
 */
export function deriveDialogueLogTitle(
  rawTitle: string,
  rawBody: string,
  type: DialogueLogType,
): string {
  const trimmedTitle = rawTitle.trim();
  if (trimmedTitle.length > 0) {
    return trimmedTitle;
  }

  const firstNonEmptyLine = rawBody
    .split('\n')
    .map((line) => line.trim())
    .find((line) => line.length > 0);
  if (firstNonEmptyLine) {
    return firstNonEmptyLine.length > MAX_DERIVED_TITLE_LENGTH
      ? `${firstNonEmptyLine.slice(0, MAX_DERIVED_TITLE_LENGTH)}…`
      : firstNonEmptyLine;
  }

  if (type === 'email') return 'メール';
  if (type === 'other') return 'その他';
  return 'タイムライン';
}
